export class LlmTemperatureDTO {
    id: string;
    name: string;
    value: number;
    description: string;
    isSelected?: boolean;
  isDefault: boolean;

    constructor(data?: Partial<LlmTemperatureDTO>) {
        if (data) {
            this.bindData(data);
        } else {
            this.initialize();
        }
    }

    bindData(data: Partial<LlmTemperatureDTO>): void {
        if (data) {
            this.id = data.id || '';
            this.name = data.name || '';
            this.value = data.value !== undefined ? data.value : 0.4;
            this.description = data.description || '';
            this.isSelected = data.isSelected || false;
            this.isDefault = data.isDefault || false;
        }
    }

    private initialize(): void {
        this.id = '';
        this.name = '';
        this.value = 0.4;
        this.description = '';
        this.isSelected = false;
        this.isDefault = false;
    }
}
